import { useChat } from "@/context/ChatContext";

function toEmbed(url) {
  const u = (url || "").trim();
  let m;
  if ((m = u.match(/youtu\.be\/([\w-]+)/))) return `https://www.youtube.com/embed/${m[1]}`;
  if ((m = u.match(/youtube\.com\/watch\?.*v=([\w-]+)/))) return `https://www.youtube.com/embed/${m[1]}`;
  if ((m = u.match(/youtube\.com\/embed\/([\w-]+)/))) return `https://www.youtube.com/embed/${m[1]}`;
  if ((m = u.match(/vimeo\.com\/(\d+)/))) return `https://player.vimeo.com/video/${m[1]}`;
  return null;
}

export default function VideoSection() {
  const { settings } = useChat();
  const embed = toEmbed(settings.video_url);
  if (!embed) return null;

  return (
    <section id="video" className="scroll-mt-24 bg-white py-24 md:py-32" data-testid="video-section">
      <div className="mx-auto max-w-4xl px-5 sm:px-6">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-600">Vídeo</p>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
          Conheça a Isabela
        </h2>
        <div className="mt-8 overflow-hidden rounded-[2rem] border border-slate-200 shadow-2xl shadow-brand-900/10">
          <iframe
            data-testid="video-embed"
            src={embed}
            title="Vídeo da Isabela Guedes"
            className="aspect-video w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
